<template>
	<svg :width="windowWidth" :height="windowHeight" xmlns="http://www.w3.org/2000/svg"
	:class="['svg-mask', { 'allow-interaction': allowInteraction }]">
		<defs>
			<mask id="element-mask">
				<rect x="0" y="0" :width="windowWidth" :height="windowHeight" fill="white"/>
				<SVGElementMask
					v-for="(mask, index) in safeMasks"
					:key="index"
					v-bind="mask"
				/>
			</mask>
			<clipPath id="element-clip">
				<SVGElementClips :shapes="svgsonArray" :width="windowWidth" :height="windowHeight" />
			</clipPath>
		</defs>
		<rect x="0" y="0" :width="windowWidth" :height="windowHeight"
			fill="currentColor" clip-path="url(#element-clip)" pointer-events="auto" />
	</svg>
</template>


<script>
import SVGElementMask from "@/components/base/SVGElementMask";
import SVGElementClips from "@/components/base/SVGElementClips";

export default {
	name: 'SVGMask',
	components: {
		SVGElementMask,
		SVGElementClips,
	},
	props: {
		masks: {
			type: [String, Array, Object],
			required: true,
		},
		padding: {
			type: Number,
			default: 0,
		},
		rounded: {
			type: Number,
			default: 7.5,
		},
		circle: {
			type: Boolean,
			default: false,
		},
		allowInteraction: {
			type: Boolean,
			deafult: true,
		},
	},
	data() {
		return {
			windowWidth: 0,
			windowHeight: 0,
			elementMasks: [],
		};
	},
	computed: {
		defaultSettings() {
			return { padding: this.padding, rounded: this.rounded };
		},
		safeMasks() {
			const safe = this.elementMasks.filter((mask) => mask.targetWidth >= 0 && mask.targetHeight >= 0
				&& mask.targetTop >= 0 && mask.targetLeft >= 0);
			return safe;
		},
		svgsonArray() {
			const masks = this.safeMasks.map(this.makeSVGSON);
			return masks;
		},
	},
	methods: {
		buildMasks() {
			const masks = Array.isArray(this.masks) ? this.masks : [this.masks];

			this.elementMasks = masks.reduce((list, data) => {
				const mask = typeof data === "string" ? { selector: data } : data;
				const shapes = mask.element ? this.buildFromElement(mask) : this.buildFromSelector(mask);

				return Array.isArray(shapes) ? [...list, ...shapes] : [...list, shapes];
			}, []);
		},
		buildFromSelector(mask) {
			const elements = document.querySelectorAll(mask.selector);
			return [...elements].map((element) => this.buildFromElement({ ...mask, element }));
		},
		buildFromElement(mask) {
			const settings = this.buildMaskSettings(mask);
			return this.buildShape(mask.element, settings);
		},
		buildMaskSettings(mask) {
			return mask.settings ? { ...this.defaultSettings, ...mask.settings } : this.defaultSettings;
		},
		buildShape(element, settings) {
			return { ...this.getTargetSize(element), ...settings };
		},

		getTargetSize(element) {
			const { width, height, top, left } = element.getBoundingClientRect();
			return { targetWidth: width, targetHeight: height, targetTop: top, targetLeft: left };
		},
		update() {
			this.windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			this.windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
			this.buildMasks();
		},
		getRectSettings(mask) {
			return {
				x: mask.targetLeft - mask.padding,
				y: mask.targetTop - mask.padding,
				width: mask.targetWidth + (mask.padding * 2),
				height: mask.targetHeight + (mask.padding * 2),
				rx: mask.rounded,
			};
		},
		getCircleSettings(mask) {
			const width = (mask.targetWidth + mask.padding);
			const height = (mask.targetHeight + mask.padding);

			return {
				cx: mask.targetLeft + (mask.targetWidth / 2),
				cy: mask.targetTop + (mask.targetHeight / 2),
				r: Math.max(width, height) / 2,
			};
		},
		makeSVGSON(mask) {
			return {
				name: mask.circle ? "circle" : "rect",
				attributes: mask.circle ? this.getCircleSettings(mask) : this.getRectSettings(mask),
			};
		},
	},
	mounted() {
		this.update();
		window.addEventListener('resize', this.update);
	},
	watch: {
		masks() {
			this.update();
		},
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.update);
	},
};
</script>

<style lang="scss" scoped>
	.svg-mask {
		opacity: 0.7;
		width: 100%;
		left: 0;
		top: 0;
		height: 100%;
		position: fixed;
		z-index: $z-top;
		color: #000;
		pointer-events: all;

		&.allow-interaction {
			pointer-events: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/SVGMask.vue